<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-900 px-4">
    <div class="w-full max-w-md p-6 bg-gray-800 rounded-lg shadow-lg space-y-6">
      <h2 class="text-2xl font-bold text-center text-white">2-Step Authentication</h2>

      <div v-if="qrDataUrl" class="flex justify-center">
        <img :src="qrDataUrl" alt="Scan QR code" class="w-48 h-48 rounded" />
      </div>

      <div class="text-center text-gray-300">
        Scan the QR code with Google Authenticator or any TOTP app.<br />
        Then enter the 6-digit code when logging in.
      </div>

      <div v-if="secret" class="text-xs text-center text-gray-400">
        Secret (for backup): <span class="font-mono break-all">{{ secret }}</span>
      </div>

<!--      <button-->
<!--          @click="loadQR"-->
<!--          class="w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700"-->
<!--      >-->
<!--        Generate New QR-->
<!--      </button>-->
      <!-- Buttons -->
      <div class="flex space-x-4">
        <button
            @click="loadQR"
            class="flex-1 py-2 px-4 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700"
        >
          Generate New QR
        </button>

        <button
            @click="goNext"
            class="flex-1 py-2 px-4 bg-green-600 text-white font-semibold rounded hover:bg-green-700"
        >
          Next
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import {RequestManager} from "@/utils/RequestManager";
import EventBus from "@/utils/EventBus";

export default {
  name: 'TfAuth',
  props: {
    request: {
      type: RequestManager,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      secret: '',
      qrDataUrl: ''
    };
  },
  mounted() {
    this.loadQR();
  },
  methods: {
    async loadQR() {
      // const
      const response = await this.request.enable2FA(this.userName);
      if (response.error) return console.error(response.error);
      const { otpauth_url, secret } = response;
      this.qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(otpauth_url)}`;
      this.secret = secret;
    },
    goNext() {
      if(!this.secret) return alert('Data not loaded!');
      EventBus.emit('newTFAClicked', {
        secret: this.secret,
      });
    }
  }
}

</script>
